import { useQuery } from "@tanstack/react-query";
import {
  type GetTransactionStatusData,
  EnumCashierTxStatus,
} from "@/api/cashier";

import { getTransactionStatusOptions } from "@/api/cashier/@tanstack/react-query.gen";

const FINAL_STATUSES = new Set<EnumCashierTxStatus>([
  EnumCashierTxStatus.CashierTxComplete,
  EnumCashierTxStatus.CashierTxCancelled,
  EnumCashierTxStatus.CashierTxUnsuccessful,
]);

const FAST_POLL_COUNT = 5;
const FAST_POLL_INTERVAL = 1000;
const SLOW_POLL_INTERVAL = 5000;

interface GetTransactionsStatusParams {
  transactionType: GetTransactionStatusData["query"]["payment-type"];
  referenceId: GetTransactionStatusData["path"]["referenceID"];
}

export const useGetTransactionsStatus = ({
  transactionType,
  referenceId,
}: GetTransactionsStatusParams) => {
  return useQuery({
    ...getTransactionStatusOptions({
      path: {
        referenceID: referenceId,
      },
      query: {
        "payment-type": transactionType,
      },
    }),
    enabled: Boolean(transactionType && referenceId),
    refetchInterval: (query) => {
      const data = query.state.data;

      if (data && FINAL_STATUSES.has(data.status)) return false;

      if (query.state.fetchFailureCount > 0) return SLOW_POLL_INTERVAL;

      return query.state.dataUpdateCount < FAST_POLL_COUNT
        ? FAST_POLL_INTERVAL
        : SLOW_POLL_INTERVAL;
    },
  });
};
